module.exports = __webpack_public_path__ + "img/BoCM_Small_White@2x.57816e0b.png";